import { action } from 'easy-peasy';
import { IActionAddCrisisCallTeamMemberAllocations } from '../types';
import { createTeamMemberWithFilteredAllocations, upsertTeamMemberAllocations } from './helpers';

const addCrisisCallTeamMemberAllocations: IActionAddCrisisCallTeamMemberAllocations = action(
  (state, payload) => {
    payload.forEach(incomingMember => {
      const existingMember = state.crisisCallTeamMembers.find(
        member => member.id === incomingMember.id,
      );

      if (existingMember) {
        upsertTeamMemberAllocations(existingMember, incomingMember);
        return;
      }

      const newMember = createTeamMemberWithFilteredAllocations(incomingMember);

      if (newMember.allocatedClients.length) {
        state.crisisCallTeamMembers.push(newMember);
      }
    });
  },
);

export default addCrisisCallTeamMemberAllocations;
